import * as React from 'react';
import ClientManager from './client-manager';
import Client from '../../../../models/client';

const AddClient = () => {
  let client = {
    name: '',
    displayName: '',
    supportEmail: '',
    brandImage: '',
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    description: '',
    addressOne: '',
    addressTwo: '',
    city: '',
    state: 0,
    zipCode: '',
    status: true,
    enableServiceDesk: false,
    enableSegmentation: false,
    assignedAdministrators: [],
    assignedUsers: [],
    assignedOrganizations: [],
    assignedRequestTypes: [],
    hiddenRequestTypeFields: []
  } as Client;

  return (
    <React.Fragment>
      <h1>Add Client</h1>
      <ClientManager client={client} isNewClient={true} />
    </React.Fragment>
  );
};

export default AddClient;
